import { useEffect, useMemo, useState } from "react";
import { axios } from "helper/axios";

const OFFERS_API = "dashboard/offers";

const EMPTY_OFFER = {
  offerShow: false,
  offerName: null,
  discountOffer: null,
  discountLabel: null,
  endDate: null,
  endsAt: null,
};

const parseOfferResponse = (response) => {
  const data = response?.data ?? response ?? {};
  const offerShow = data.OfferShow === true || data.offerShow === true;
  const offerName = data.OfferName ?? data.offerName ?? null;
  const discountOffer = data.DiscountOffer ?? data.discountOffer ?? null;
  const endDate = data.endDate ?? data.EndDate ?? null;

  let discountLabel = null;
  if (discountOffer) {
    const raw = String(discountOffer).trim();
    discountLabel = /discount/i.test(raw) ? raw : `${raw} discount`;
  }

  let endsAt = null;
  if (endDate) {
    const asDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(endDate).trim());
    const ms = new Date(
      asDateOnly ? `${String(endDate).trim()}T23:59:59+05:30` : endDate,
    ).getTime();
    endsAt = Number.isNaN(ms) ? null : ms;
  }

  return {
    offerShow,
    offerName,
    discountOffer,
    discountLabel,
    endDate,
    endsAt,
  };
};

export const useDashboardOffer = () => {
  const [offer, setOffer] = useState(EMPTY_OFFER);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const response = await axios.get(OFFERS_API, {
          skipErrorToast: true,
        });

        if (!cancelled) {
          setOffer(parseOfferResponse(response));
        }
      } catch (error) {
        console.error("Failed to load dashboard offers:", error);
        if (!cancelled) {
          setOffer(EMPTY_OFFER);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const isActive = useMemo(() => {
    if (!offer.offerShow || !offer.endsAt) return false;
    return offer.endsAt > Date.now();
  }, [offer.offerShow, offer.endsAt]);

  return {
    offer,
    isActive,
    loading,
  };
};

export default useDashboardOffer;
